import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';
import {redirectToLogin, secureReplace} from '../../utils/helpers';
import { constants } from '../../utils/constants';
import Parser from 'html-react-parser';

class Error extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var errorText = '';
    var persistsText = '';

    switch (this.props.message) {
      case 'EXPIRED_CLICKBACK':
        errorText = <p id='httpPersistsErrorText'>{Parser(this.translate('expiredClickbackText'))}</p>;
        break;
      default:
        errorText = <p id='httpErrorText' hidden={this.props.message === 'EXPIRED_CLICKBACK'}>{this.translate('errorText')}</p>;
        persistsText = this.translate('errorPersistsText');
        persistsText = secureReplace(persistsText, 'guestServicesLinkA', `<a id="errorGuestServicesLink" href="${constants.customerServiceHref}" target='_blank'>`);
        persistsText = secureReplace(persistsText, 'guestServicesLinkB', `</a>`);
        persistsText = <p id='httpPersistsErrorText'>{Parser(persistsText)}</p>;
        break;
    }

    return (
      <div className='messageContainer error'>
        <svg id="Layer_1" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 31 32" style={{'enableBackground': 'new 0 0 31 32'}} aria-labelledby='error-title' role='img'>
          <title id='error-title'>Error</title>
          <g id="Page-1">
              <g id="" transform="translate(0.000000, 3.000000)">
                  <g className="st0">
                      <path id='errorOval' className="st1" d="M30.9,13.1c0,8.5-6.9,15.4-15.4,15.4S0,21.7,0,13.1S6.9-2.3,15.4-2.3S30.9,4.6,30.9,13.1z M18.3,3.4
                          c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.5-0.2h-4.4c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.2-0.2,0.4l0.3,12.5
                          c0,0.3,0.3,0.5,0.7,0.5h3.7c0.4,0,0.7-0.2,0.7-0.5L18.3,3.4z M18,18.9c0-0.4-0.3-0.7-0.6-0.7h-3.9c-0.4,0-0.7,0.3-0.7,0.7v3.8
                          c0,0.4,0.3,0.7,0.7,0.7h3.9c0.3,0,0.6-0.3,0.6-0.7V18.9z"/>
                  </g>
              </g>
          </g>
        </svg>

        <div className='main-content centeredText'>
          {errorText}
          {persistsText}
        </div>
      </div>
    );
  }
}

TranslatedComponent(Error);
module.exports = Error;



// WEBPACK FOOTER //
// ./client/src/components/messages/Error.jsx